var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlgeria(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_7077)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256 0C397.384 0 512 114.616 512 256C512 397.384 397.384 512 256 512C256 500.87 222.609 256 222.609 256L256 0Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 512C114.616 512 0 397.384 0 256C0 114.616 114.616 0 256 0",
    fill: "#496E2D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.003 206.896L289.999 235.841L255.982 224.809L277.02 253.729L256.018 282.674L290.022 271.603L311.06 300.522L311.038 264.761L345.043 253.689L311.027 242.659L311.003 206.896Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.237 328.348C237.281 328.348 204.889 295.956 204.889 256C204.889 216.044 237.281 183.652 277.237 183.652C289.695 183.652 301.418 186.802 311.652 192.348C295.596 176.647 273.64 166.956 249.411 166.956C200.233 166.956 160.368 206.822 160.368 255.999C160.368 305.176 200.234 345.042 249.411 345.042C273.641 345.042 295.597 335.351 311.652 319.65C301.418 325.198 289.695 328.348 277.237 328.348Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_7077"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlgeria);
export default __webpack_public_path__ + "static/media/algeria.24bcb9df30de4d821e1a4c96bc6388c8.svg";
export { ForwardRef as ReactComponent };